import { render, staticRenderFns } from "./desktopMain.vue?vue&type=template&id=4fc40826"
import script from "./desktopMain.vue?vue&type=script&lang=js"
export * from "./desktopMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports